import { useParams } from 'react-router-dom';

import { useGenerateNoteMutation } from 'features/sessions/hooks/mutation/useGenerateNote';

export const useNoteGenerator = (noteStructure: string) => {
  const { sessionId } = useParams();

  const { isLoading, isError, mutateAsync, reset } = useGenerateNoteMutation({
    sessionId: sessionId!,
  });

  const generateNote = () => {
    reset();
    mutateAsync({ noteStructure });
  };

  return {
    generateNote,
    isLoading,
    isError,
  };
};
